<template>
  <div class="mk-checkout">
    <ContactPopup v-if="contactShown" :closeCallback="closeContact" :itemData="{
        list: items,
        totalPrice: totalPrice,
        totalNet: totalPrice,
        totalTax: 0,
        currencySymbol: currencySymbol,
        area: area,
      }"
      :offerId="offerId"
    />
    <CreateOfferPopup
      v-if="createOfferShown"
      :closeCallback="() => {createOfferShown = false}"
      :offerId="offerId"
    />
    <MessagePopup
      :closeCallback="() => {message = ''; messageTitle = ''}"
      :message="message"
      :title="messageTitle"
      v-if="message !== ''"
    />
    <span class="mk-checkout__title"></span>
    <div class="mk-checkout__item mk-checkout__item--head">
      <div
        class="mk-checkout__item__col mk-checkout__item__col--narrow mk-checkout__item__col--name"
      >
        {{$t('checkout.itemName')}}
      </div>
      <div class="mk-checkout__item__col mk-checkout__item__col--narrow">
        {{$t('checkout.quantity')}}
      </div>
      <div class="mk-checkout__item__col">
        {{$t('checkout.unitPrice')}}
      </div>
      <div class="mk-checkout__item__col">
       {{$t('checkout.extendedPrice')}}
      </div>
    </div>
    <div class="mk-checkout__container">
      <div
        class="mk-checkout__item"
        v-for="(item, index) in items"
        :key="`mk-item-${index}`"
      >
        <div class="mk-checkout__item__col mk-checkout__item__col--name">{{item.description}}</div>
        <div
          class="
            mk-checkout__item__col
            mk-checkout__item__col--right
            mk-checkout__item__col--narrow
          "
        >
          {{item.quantity}}
        </div>
        <div class="mk-checkout__item__col mk-checkout__item__col--right">
          {{currencySymbol}}{{item.price}}
        </div>
        <div class="mk-checkout__item__col mk-checkout__item__col--right">
          {{currencySymbol}}{{item.total}}
        </div>
      </div>
      <div
        class="mk-checkout__item"
      >
        <div class="mk-checkout__item__col mk-checkout__item__col--name">
          {{$t('checkout.packagingIncluded')}}
        </div>
        <div
          class="
            mk-checkout__item__col
            mk-checkout__item__col--right
            mk-checkout__item__col--narrow
          "
        >
          1
        </div>
        <div class="mk-checkout__item__col mk-checkout__item__col--right">{{currencySymbol}}0</div>
        <div class="mk-checkout__item__col mk-checkout__item__col--right">{{currencySymbol}}0</div>
      </div>
      <div
        class="mk-checkout__item"
      >
        <div class="mk-checkout__item__col mk-checkout__item__col--name">
          {{$t('checkout.shipping')}}
        </div>
        <div
          class="
            mk-checkout__item__col
            mk-checkout__item__col--right
            mk-checkout__item__col--narrow
          "
        >
          1
        </div>
        <div class="mk-checkout__item__col mk-checkout__item__col--right">
          {{$t('checkout.toBeDetermined')}}
        </div>
        <div class="mk-checkout__item__col mk-checkout__item__col--right">
          {{$t('checkout.toBeDetermined')}}
        </div>
      </div>
    </div>
    <hr>
    <div class="mk-checkout__item mk-checkout__item--total">
      <div class="mk-checkout__item__col"></div>
      <div class="mk-checkout__item__col mk-checkout__item__col--name">
        {{$t('checkout.totalNet')}}:
      </div>
      <div class="mk-checkout__item__col">{{totalPrice}}{{currencySymbol}}</div>
    </div>
    <div class="mk-checkout__buttons">
      <div class="mk-checkout__buttons__row">
        <button
          class="mk-checkout__buttons__secondary"
          @click="generatePDF"
        >
          <span v-if="!pdfLoading">
            {{$t('checkout.createPdf')}}
          </span>
          <LoadingIcon class="mk-checkout__buttons__spinner" v-if="pdfLoading"/>
        </button>
        <button
          v-if="!customerData.firstName"
          class="mk-checkout__buttons__primary"
          @click="contactShown=true"
        >
          {{$t('checkout.sendRequest')}}
        </button>
        <button
          v-if="customerData.firstName"
          class="mk-checkout__buttons__primary"
          @click="createOfferShown=true"
        >
          Create Offer
        </button>
      </div>
      <button
        class="mk-checkout__buttons__primary"
        @click="buyNow"
      >
        <span v-if="!buyLoading">
          {{$t('checkout.buy')}}
        </span>
        <span v-if="buyLoading" class="mk-checkout__buttons__loading">
          <LoadingIcon class="mk-checkout__buttons__spinner"/>
          {{$t('checkout.buyLoading')}}
        </span>
      </button>
    </div>
  </div>
</template>

<script>
/**
 * Checkout
 * @author David <david.prenninger@gmx.de>
 *
 * This component is part of the main configurator Sections.
 * It shows the final configuration and gives the user the
 * oportunity to generate a pdf or contact mk-solutions.
 *
 */
import LoadingIcon from 'vue-material-design-icons/Loading.vue';
import { getOfferID, generatePDF, addToCart } from '../helpers/api';
import DownloadHelper from '../helpers/download';
import ContactPopup from '../components/ContactPopup.vue';
import CreateOfferPopup from '../components/CreateOfferPopup.vue';
import MessagePopup from '../components/MessagePopup.vue';
import { PAGE_AREA, SERVER_ADDRESS } from '../constants';

export default {
  components: {
    ContactPopup,
    CreateOfferPopup,
    MessagePopup,
    LoadingIcon,
  },
  computed: {
    objectSections() {
      return this.$store.getters.objectSections;
    },
    customerData() {
      return this.$store.getters.customerAgentData;
    },
  },
  data() {
    return {
      items: [],
      totalPrice: 0,
      currencySymbol: '€',
      contactShown: false,
      createOfferShown: false,
      message: '',
      messageTitle: '',
      offerId: 'not_set',
      pdfLoading: false,
      buyLoading: false,
      area: PAGE_AREA,
    };
  },
  mounted() {
    getOfferID().then((data) => {
      this.offerId = data.id;
    });

    const items = {};
    let objects = [];
    this.objectSections.forEach((section) => {
      objects.push(
        section.connector,
        section.stand,
        section.glass,
        section.clamp1,
        section.clamp2,
      );
    });
    objects = objects.filter((element) => element !== undefined);

    objects.forEach((object) => {
      if (items[object.id]) {
        if (items[object.id].type === 'connector') {
          items[object.id].quantity += 2;
          items[object.id].total += object.price * 2;
        } else {
          items[object.id].quantity += 1;
          items[object.id].total += object.price;
        }
      } else if (object.type === 'connector') {
        items[object.id] = { ...object, quantity: 2, total: object.price * 2 };
      } else {
        items[object.id] = { ...object, quantity: 1, total: object.price };
      }
    });

    Object.keys(items).forEach((itemId) => {
      this.items.push({
        ...items[itemId],
        total: Number(items[itemId].total).toFixed(2),
        price: Number(items[itemId].price).toFixed(2),
      });
      this.totalPrice += items[itemId].price * items[itemId].quantity;
    });

    this.totalPrice = Number(this.totalPrice).toFixed(2);

    this.items.sort((a, b) => {
      if (a.id < b.id) { return -1; }
      if (a.id > b.id) { return 1; }
      return 0;
    });

    switch (this.area) {
      case 'DE':
        this.currencySymbol = '€';
        break;
      case 'US':
        this.currencySymbol = '$';
        break;
      case 'DK':
        this.currencySymbol = 'DL';
        break;
      default:
        this.currencySymbol = '€';
        break;
    }
  },
  methods: {
    generatePDF() {
      this.pdfLoading = true;
      generatePDF({
        list: this.items,
        totalPrice: this.totalPrice,
        totalNet: this.totalPrice,
        totalTax: 0,
        currencySymbol: this.currencySymbol,
        area: this.area,
        offerId: this.offerId,
        link: window.location.href,
      }).then((data) => {
        DownloadHelper.downloadURI(SERVER_ADDRESS + data.pdf);
        this.pdfLoading = false;
      });
    },
    closeContact(success = undefined) {
      if (typeof success !== 'undefined') {
        if (success) {
          this.messageTitle = this.$t('contact.successTitle');
          this.message = this.$t('contact.successMessage');
        } else {
          this.messageTitle = 'Error';
          this.message = 'Something went wrong please try again!';
        }
      }
      this.contactShown = false;
    },
    buyNow() {
      this.buyLoading = true;
      addToCart(this.items);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/defaults.scss";

.mk-checkout {
  width: 700px;
  padding: 20px;
  box-sizing: content-box;
  border-right: 1px solid $c_primary_light;
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    border-right: none;
    border-top: 1px solid $c_primary_light;
    width: calc(100% - 20px);
    padding: 10px;
    height: 600px;
  }

  &__title {
    font-size: 20px;
    text-align: left;
  }

  &__container {
    flex-grow: 1;
    overflow-y: auto;
  }


  &__item {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;
    box-sizing: content-box;
    border-bottom: 1px solid $c_primary_light;
    font-size: 12px;

    &--total {
      flex: 0 0 auto;
      font-size: 16px;
      font-weight: bold;
    }

    &--head {
      flex: 0 0 auto;
      font-size: 14px;
      font-weight: bold;
    }


    &__col {
      padding: 0 5px;
      width: 70px;

      &--narrow {
        width: 45px;
      }

      &--right {
        text-align: right;
      }

      &--name {
        text-align: left;
        width: 56%;
      }
    }
  }

  &__buttons {
    flex: 0 0 auto;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;

    &__row {
      display: flex;
      flex-direction: row;
    }

    &__primary {
      background-color: $c_accent;
      box-shadow: $bs_md;
      padding: 10px 15px;
      box-sizing: content-box;
      border: none;
      border-radius: $br_md;
      color: $c_white;
      text-transform: uppercase;
      margin: 5px;

      &:not(.toggle) {
        background-color: $c_accent;
      }
    }

    &__secondary {
      display: flex;
      justify-content: center;
      border: none;
      padding: 10px 10px;
      margin: 5px;
      box-sizing: content-box;
      box-shadow: $bs_md;
      border-radius: $br_md;
      text-transform: uppercase;
      min-width: 120px;
      transform: width 1s;

      &:not(.toggle) {
        background-color: $c_white;
      }
    }

    &__spinner > * {
      animation: spin 2s linear infinite;
      height: 20px;
      font-size: 24px;
    }

    &__loading {
      display: flex;
    }

    &__spinner {
      margin-right: 15px;
    }

    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
  }
}
</style>
